import { render, staticRenderFns } from "./user-center-dialog-iframe.vue?vue&type=template&id=70121a6c&scoped=true&"
import script from "./user-center-dialog-iframe.vue?vue&type=script&lang=js&"
export * from "./user-center-dialog-iframe.vue?vue&type=script&lang=js&"
import style0 from "./user-center-dialog-iframe.vue?vue&type=style&index=0&id=70121a6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70121a6c",
  null
  
)

export default component.exports